<template>
  <we-modal 
    v-model="showModal" 
    modal-size="w-screen md:w-[496px]" 
    no-close-button
    @close="handleClose"
  >
    <template #content>
      <!-- Carregando -->
      <div v-if="isVerifying" class="pt-20 font-bold text-3xl text-primary-brand-400 px-6 flex flex-col">
        Verificando status do contrato
        <div class="w-full bg-contrast-brand-100 h-1.5 mt-6 relative">
          <div class="bg-contrast-brand-300 h-1.5 absolute left-0 transition-all ease-linear duration-1000"
            :style="{ width: '50%' }" />
        </div>
      </div>

      <!-- Aprovado -->
      <div v-else-if="verificationResult?.approved" class="pt-20 font-bold text-3xl text-primary-brand-400 px-6">
        <we-icon name="done" class="fill-primary-brand-400 mb-5" size="60px" />
        Contrato Aprovado!
        <p class="text-primary-brand-200 font-semibold text-base my-3">
          Sua contratação foi aprovada com sucesso. Vamos dar continuidade ao seu cadastro.
        </p>
        <div class="w-full mt-5">
          <we-button class="w-full bg-contrast-brand-300 rounded-full text-white font-extrabold text-lg" label="Continuar"
            :action="handleApproved" no-border no-icon />
        </div>
      </div>

      <!-- Rejeitado-->
      <div v-else class="pt-20 font-bold text-3xl text-[#F66450] px-6">
        <we-icon name="error_exclamation_point" class="fill-[#F66450] mb-5" size="60px" />
        Contrato Não Aprovado
        <p class="text-primary-brand-200 font-semibold text-base my-3">
          Desculpe, sua contratação não foi aprovada neste momento. Por favor, entre em contato com nosso suporte.
        </p>
        <div class="w-full mt-5">
          <we-button class="w-full bg-contrast-brand-300 rounded-full text-white font-extrabold text-lg" label="Voltar ao site"
            :action="handleRejected" no-border no-icon />
        </div>
      </div>
    </template>
  </we-modal>
</template>

<script setup>
  import { computed } from 'vue'
  import { useStore } from 'vuex'
  import WeModal from './WeModal'
  import WeButton from './WeButton'
  import WeIcon from './WeIcon'

  const store = useStore()

  const showModal = computed({
    get: () => store.getters.getShowVerificationModal,
    set: (value) => {
      if (!value) {
        store.dispatch('contractVerification/closeVerificationModal')
      }
    }
  })

  const isVerifying = computed(() => store.getters.getIsVerifying)
  const verificationResult = computed(() => store.getters.getVerificationResult)

  const handleClose = () => {
    showModal.value = false
  }

  const handleApproved = () => {
    store.dispatch('contractVerification/closeVerificationModal')
    // Aqui você pode adicionar lógica adicional se necessário
  }

  const handleRejected = () => {
    window.location = process.env.VUE_APP_WECLIX_SITE ?? 'https://www.weclix.com.br'
    localStorage.clear()
    store.dispatch('contractVerification/closeVerificationModal')
  }
</script>
